import Summary from "../../../components/reports/summary"

const Index = () => {
    return <Summary />
}

export default Index;